import { CastDto } from '@cineamo/api/models/movie/CastDto.types';
import { CrewDto } from '@cineamo/api/models/movie/CrewDto.types';

export type CustomContentMovie = {
    title: string;
    originalTitle?: string;
    description: string;
    originalLanguage?: string;
    productionCountries?: string[];
    releaseDate?: string;
    cast?: (CastDto & { imageUrl?: string })[];
    crew?: (CrewDto & { imageUrl?: string })[];
    runtime?: number;
    certification?: string;
    posterUrl?: string;
    backdropUrl?: string;
    trailer?: string;
};

export type CustomContent = {
    movies: CustomContentMovie[];
    title?: string;
    description?: string;
    posterUrl?: string;
    backdropUrl?: string;
};

type CustomContents = Record<number, CustomContent>;

const baran: CustomContent = {
    movies: [
        {
            title: 'Baran - Der letzte Regen',
            originalTitle: 'Akharin Baran',
            description:
                'In "Baran - Der letzte Regen" entfaltet sich ein spannungsgeladenes Familiendrama während einer Revolution im Iran. Als die leidenschaftliche Theaterstudentin Baran gegen die autoritäre Ordnung aufbegehrt, gerät sie in einen gefährlichen Konflikt mit ihrem Bruder Mahmood, der auf der Seite der Sicherheitskräfte steht. Inmitten von Zensur und gesellschaftlichem Umbruch müssen die Familienmitglieder ihre Loyalitäten und Überzeugungen hinterfragen. Ein eindringlicher Kurzfilm, der die Herzen berührt und die Komplexität menschlicher Beziehungen in turbulenten Zeiten einfängt.',
            originalLanguage: 'Persisch, Iranisch',
            productionCountries: ['Deutschland', 'Iran', 'Kanada'],
            releaseDate: '2024-11-02',
            runtime: 18,
            certification: 'FSK18',
            cast: [
                { name: 'Taies Farzan', imageUrl: '/tmp/profile-taies_farzan.png' },
                { name: 'Mehdi Bajestani', imageUrl: '/tmp/profile-mehdi_bajestani.png' },
                { name: 'Ava Azadeh', imageUrl: '/tmp/profile-ava_azadeh.png' },
                { name: 'Armin Moallem', imageUrl: '/tmp/profile-armin_moallem.png' },
                { name: 'Nima Mehrabani', imageUrl: '/tmp/profile-nima_mehrabani.png' },
                { name: 'Reza Vaghef', imageUrl: '/tmp/profile-reza_vaghef.png' }
            ],
            crew: [
                { name: 'Masoud Ghahremani', job: 'Produzent', imageUrl: '/tmp/profile-masoud_ghahremani.png' },
                { name: 'Masoud Ghahremani', job: 'Regie', imageUrl: '/tmp/profile-masoud_ghahremani.png' },
                { name: 'Emily Ahmad', job: 'Drehbuch' },
                { name: 'Florian Linke', job: 'Kamera' },
                { name: 'Christian Henschel', job: 'Kamera Operator' },
                { name: 'Kathrin Grzeschniok', job: '1. Kameraassitentin' },
                { name: 'Joel Notthoff', job: '1. Kameraassitent' },
                { name: 'Karsten Jäger', job: 'Stadycam Operator' },
                { name: 'Julius Hesse', job: 'Oberbeleuchter' },
                { name: 'Florian Gudzian', job: 'Oberbeleuchter' },
                { name: 'Ronja Frühe', job: 'Beleuchterin' },
                { name: 'Christin Kirschnek', job: 'Lichtassistentin' },
                { name: 'Noel Lardon', job: 'Colorist' },
                { name: 'Viviann Banh', job: 'Editorin' },
                { name: 'Jonathan Dönges', job: 'Filmton Meister' },
                { name: 'Lis Demiri', job: 'Filmton Meister' },
                { name: 'Hendrik Feller', job: 'Sound supervisor' },
                { name: 'Jenny Winter', job: 'Sound designer' },
                { name: 'Aaron Shahi', job: 'Musik-Komponist' },
                { name: 'Ramon Gonzalez', job: 'Musikproduzent' },
                { name: 'Anais Jardin', job: 'Kostümbildnerin' },
                { name: 'Melina Eskandari', job: 'Maskenbildnerin' },
                { name: 'Fatemeh-Zahra Pirhadi', job: 'Szenenbildnerin' },
                { name: 'Johannes Weber', job: 'Set-Requisiteur' },
                { name: 'Pegah Etessami- Pour', job: 'Herstellungsleiterin' },
                { name: 'Regina Rein', job: 'Produktionsleiterin' }
            ],
            posterUrl: '/tmp/poster-baran_the_last_rain.jpeg',
            backdropUrl: '/tmp/poster-baran_the_last_rain.jpeg',
            trailer: 'https://www.youtube.com/watch?v=goxj6sjpKxI'
        }
        // {
        //     title: '(N)irgendwo in Deutschland',
        //     originalTitle: '(N)irgendwo in Deutschland',
        //     description:
        //         'Als erster dokumentarischer One-Shot-Film Deutschlands bietet "(N)irgendwo in Deutschland" einen einzigartigen Blick auf die berühmte Kiefernstraße in Düsseldorf. Ohne Schnitte folgt die Kamera Florian, der sich bewusst für ein Leben in diesem bunten, multikulturellen Viertel entschieden hat. Der Film fängt die Essenz eines Ortes ein, der durch Hausbesetzungen bekannt wurde und sich zu einem lebendigen Künstlerviertel entwickelt hat. Er porträtiert die vielfältigen Bewohner, ihre kreativen Wohnräume und ihren Alltag, während er subtil die Frage aufwirft, ob die Kiefernstraße als Mikrokosmos für ein modernes, vielfältiges Deutschland stehen kann. Entdecken Sie die wahre Bedeutung von Vielfalt und stellen Sie sich die Frage: Ist dies das Deutschland von morgen?',
        //     originalLanguage: 'Deutsch',
        //     productionCountries: ['Deutschland'],
        //     releaseDate: '2024-11-02',
        //     runtime: 105,
        //     certification: 'FSK18',
        //     cast: [],
        //     crew: [
        //         { name: 'Masoud Ghahremani', job: 'Produzent', imageUrl: '/tmp/profile-masoud_ghahremani.png' },
        //         { name: 'Masoud Ghahremani', job: 'Regie', imageUrl: '/tmp/profile-masoud_ghahremani.png' },
        //         { name: 'Laura-Alina Blüming', job: 'Kamera' },
        //         { name: 'Leon-Ranjan', job: 'Ton' },
        //         { name: 'Ansgar Wacker', job: 'Color-Grading' }
        //     ],
        //     posterUrl: '/tmp/poster-nirgendwo_in_deutschland.jpeg',
        //     backdropUrl: '/tmp/poster-nirgendwo_in_deutschland.jpeg',
        //     trailer: null
        // }
    ],
    posterUrl: '/tmp/poster-baran_the_last_rain.jpeg',
    backdropUrl: '/tmp/poster-baran_the_last_rain.jpeg'
};

const pettersson: CustomContent = {
    title: 'Pettersson & Findus: Lustiges Mitmachkino',
    description:
        'Der alte Pettersson und sein Kater Findus sind zurück auf der großen Leinwand! Im Mitmachkino erleben sie auf ihrem Bauernhof am Rande eines kleinen Dorfes irgendwo in Schweden fünf lustige und spannende Abenteuer! Ein Kinospaß zum Mitsingen, Mittanzen, Mitlachen!',
    movies: [],
    posterUrl: '/tmp/poster-pettersson_und_findus_mitmachkino.png',
    backdropUrl: '/tmp/backdrop-pettersson_und_findus_mitmachkino.png'
};

export function getCustomContent(contentId: number): CustomContent {
    const customContents: CustomContents = {
        1441195: baran,
        1444081: baran,
        1450561: baran,
        1436839: pettersson,
        1450564: pettersson
    };
    return customContents[contentId];
}
